import { render, staticRenderFns } from "./Keyborad-KrutiDev-Hindi.vue?vue&type=template&id=e5e30c12&"
import script from "./Keyborad-KrutiDev-Hindi.vue?vue&type=script&lang=js&"
export * from "./Keyborad-KrutiDev-Hindi.vue?vue&type=script&lang=js&"
import style0 from "./Keyborad-KrutiDev-Hindi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports